import { cn } from '@/lib/cn';

/** A grey placeholder in the shape of the content that is loading. */
export const Skeleton = ({ className }: { className?: string }) => (
  <div
    aria-hidden
    className={cn('rounded-control bg-line', className)}
    style={{ animation: 'skeleton-pulse 1.6s ease-in-out infinite' }}
  />
);

/** Placeholder for a list or table: `rows` bars of varying width. */
export const SkeletonRows = ({ rows = 4, label = 'Loading' }: { rows?: number; label?: string }) => (
  <div role="status" aria-label={label} className="flex flex-col gap-3 py-2">
    {Array.from({ length: rows }, (_, i) => (
      <Skeleton key={i} className={cn('h-5', i % 3 === 0 ? 'w-full' : i % 3 === 1 ? 'w-5/6' : 'w-2/3')} />
    ))}
  </div>
);
